import {
    BudgetExpenseOrIncome,
    BudgetPhases,
    BudgetRealOrOrder,
} from 'business/constants';
import { MANTY_BLACK, MANTY_ORANGE, MANTY_CYAN } from 'styles/theme';
import { InscriptionT } from '../shared/entities/inscription';
import { ExtraColumn } from '../helpers/export';
import { ActiveBudgetPhases } from '../shared/phases/helpers';

export enum Colors {
    ORANGE = 'orange',
    GREEN = 'green',
    RED = 'red',
    BLACK = 'black',
    LIGHTGRAY = 'lightgray',
}

export enum DimensionType {
    Label = 'Label',
    Code = 'Code',
    SoftwareId = 'SoftwareId',
    Other = 'Other',
}

export const BUDGET_LINE_TABLE = 'budgetLine';
export const BUDGET_YEAR_FIELD = 'budgetLine.year';
export const BUDGET_PROPOSAL_PHASE = 'budgetProposal.phase';
export const ORG_CHART_FINANCE_FIELD = 'orgChartFinance.tree';
export const ORG_CHART_FINANCE_NAME_FIELD = 'orgChartFinance.name';
export const ORG_CHART_FINANCE_CODE_FIELD = 'orgChartFinance.code';
export const BUDGET_ID_FIELD = 'budget.id';
export const BUDGET_NAME_FIELD = 'budget.name';
export const BUDGET_CODE_FIELD = 'budget.code';
export const SECTION_FIELD = 'budgetLine.investmentOperating';
export const EXPENSE_INCOME_FIELD = 'budgetLine.expenseIncome';
export const AMOUNT_AVAILABLE_FIELD = 'budgetLine.amountAvailable';
export const AMOUNT_SPECIAL_AUTHORIZATION_FIELD =
    'budgetLine.amountSpecialAuthorization';
export const ORG_CHART_FINANCE_TABLE = 'orgChartFinance';
export const GESTIONNAIRE_TABLE = 'gestionnaire';
export const GESTIONNAIRE_FIELD = 'gestionnaire.name';
export const GESTIONNAIRE_CODE_FIELD = 'gestionnaire.code';
export const GESTIONNAIRE_SOFTWARE_ID = 'gestionnaire.softwareId';
export const SUPER_GESTIONNAIRE_FIELD = 'superGestionnaire.name';
export const SUPER_GESTIONNAIRE_CODE_FIELD = 'superGestionnaire.code';
export const ORG_CHART_FINANCE_SOFTWARE_ID = 'orgChartFinance.softwareId';
export const CHAPTER_FIELD = 'chapter.code';
export const CHAPTER_LABEL_FIELD = 'chapter.label';
export const CHAPTER_SOFTWARE_ID = 'chapter.softwareId';
export const NO_CHAPTER = '- PAS DE CHAPITRE';
export const BUDGET_BALANCE_TOTAL_FIELD = 'budgetBalance.totalAmount';
export const BUDGET_BALANCE_TOTAL_FIELD_WITH_REPORT =
    'budgetBalance.totalAmountWithReport';
export const FUNCTION_FIELD = 'function.number';
export const FUNCTION_LABEL_FIELD = 'function.label';
export const FUNCTION_SOFTWARE_ID = 'function.softwareId';
export const SUB_FUNCTION_FIELD = 'subFunction.number';
export const SUB_FUNCTION_LABEL_FIELD = 'subFunction.label';
export const NATURE_FIELD = 'nature.number';
export const NATURE_LABEL_FIELD = 'nature.label';
export const NATURE_SOFTWARE_ID = 'nature.softwareId';
export const NO_NATURE = '- PAS DE NATURE';
export const SUB_NATURE_FIELD = 'subNature.code';
export const SUB_NATURE_LABEL_FIELD = 'subNature.name';
export const ANALYTIC_FIELD = 'analytic.code';
export const ANALYTIC_NAME_FIELD = 'analytic.name';
export const ANALYTIC_SOFTWARE_ID = 'analytic.softwareId';
export const ANTENNA_FIELD = 'antenna.code';
export const ANTENNA_NAME_FIELD = 'antenna.name';
export const ANTENNA_SOFTWARE_ID = 'antenna.softwareId';
export const OPERATION_TABLE = 'operation';
export const OPERATION_FIELD = 'operation.code';
export const OPERATION_SOFTWARE_ID = 'operation.softwareId';
export const SECONDARY_BUDGET_AXIS_ELEMENT_CODE =
    'secondaryBudgetAxisElement.code';
export const SECONDARY_BUDGET_AXIS_ELEMENT_NAME_FIELD =
    'secondaryBudgetAxisElement.name';
export const SECONDARY_BUDGET_AXIS_ELEMENT_SOFTWARE_ID =
    'secondaryBudgetAxisElement.softwareId';
export const DRAFT_OPERATION_SOFTWARE_ID = 'draftOperation.softwareId';
export const OPERATION_NAME_FIELD = 'operation.name';
export const SUPER_OPERATION_NAME_FIELD = 'superOperation.name';
export const SUPER_OPERATION_SOFTWARE_ID = 'superOperation.softwareId';
export const SUPER_OPERATION_FIELD = 'superOperation.code';
export const DIRECTION_CODE = 'direction.code';
export const DIRECTION_LABEL = 'direction.label';
export const OPERATION_SEGMENT_TABLE = 'operationSegment';
export const BUDGET_LINE_PROGRAM_TABLE = 'budgetLineProgram';
export const SUPER_GESTIONNAIRE_NAME_FIELD = 'superGestionnaire.name';
export const REALIZED_FIELD = 'budgetLine.amountRealized';
export const MANDATED_FIELD = 'budgetLine.amountMandated';
export const REPORTED_FIELD = 'budgetLine.amountReported';
export const VOTED_FIELD = 'budgetLine.amountVoted';
export const REQUESTED_FIELD = 'budgetLine.amountRequested';
export const AMOUNT_ENGAGED_UNPAID = 'budgetLine.amountEngagedUnpaid';
export const VOTED_TOTAL_FIELD = 'budgetLine.fullAmount';
export const AMOUNT_AMENDING_DECISION_FIELD =
    'budgetLine.amountAmendingDecision';
export const AMOUNT_VOTED_SUP_FIELD = 'budgetLine.amountVotedSup';
export const PERCENT_REALIZED_FIELD = 'budgetLine.percentRealized';
export const REAL_ORDER_FIELD = 'budgetLine.realOrder';
export const LINE_CODE_FIELD = 'budgetLine.lineCode';
export const LINE_NAME_FIELD = 'budgetLine.lineName';
export const BUDGET_LINE_ID = 'budgetLine.id';
export const BUDGET_LINE_BUDGET_ID = 'budgetLine.budgetId';
const BUDGET_LINE_NATURE_ID = 'budgetLine.natureId';
const BUDGET_LINE_SUB_NATURE_ID = 'budgetLine.subNatureId';
const BUDGET_LINE_FUNCTION_ID = 'budgetLine.functionId';
const BUDGET_LINE_ANTENNA_ID = 'budgetLine.antennaId';
export const BUDGET_LINE_OPERATION_ID = 'budgetLine.operationId';
export const BUDGET_LINE_GESTIONNAIRE_ID = 'budgetLine.gestionnaireId';
const BUDGET_LINE_GESTIONNAIRE_CODE_FIELD = 'budgetLine.gestionnaire.code';
const BUDGET_LINE_ANALYTIC_ID = 'budgetLine.analyticId';
export const BUDGET_LINE_ORG_CHART = 'budgetLine.orgChartRaw';
export const BUDGET_LINE_ORG_CHART_FINANCE_ID = 'budgetLine.orgChartFinanceId';
export const BUDGET_LINE_INSCRIPTION_STEP =
    'budgetLineInscription.inscriptionStep';
export const BUDGET_LINE_INSCRIPTION_AMOUNT =
    'budgetLineInscription.inscriptionAmount';
export const SERVICE_PROPOSAL = 'serviceProposal';
export const BUDGET_LINE_CODE = 'budgetLine.code';
export const SERVICE_PROPOSAL_ID = 'serviceProposal.id';
export const SERVICE_PROPOSAL_AMOUNT = 'serviceProposal.amount';
export const SERVICE_PROPOSAL_AMOUNT_WITH_REPORT =
    'serviceProposal.amountWithReport';
export const SERVICE_PROPOSAL_COMMENT = 'serviceProposal.comment';
export const SERVICE_PROPOSAL_STATUS = 'serviceProposal.status';
export const SERVICE_PROPOSAL_ENDPOINT = 'serviceProposals';
export const SIMULATED_ARBITRATION = 'simulatedArbitration';
export const SIMULATED_ARBITRATION_ENDPOINT = 'simulatedArbitrations';
export const SIMULATED_ARBITRATED_AMOUNT = 'simulatedArbitration.amount';
export const SIMULATED_ARBITRATED_AMOUNT_WITH_REPORT =
    'simulatedArbitration.amountWithReport';
export const SIMULATED_COMMENT = 'simulatedArbitration.comment';
export const SIMULATED_ID = 'simulatedArbitration.id';
export const SIMULATED_STATUS = 'simulatedArbitration.status';
export const PRIMITIVE_BUDGET = 'primitiveBudget';
export const PRIMITIVE_BUDGET_ID = 'primitiveBudget.id';
export const PRIMITIVE_BUDGET_AMOUNT = 'primitiveBudget.amount';
export const PRIMITIVE_BUDGET_AMOUNT_WITH_REPORT =
    'primitiveBudget.amountWithReport';
export const PRIMITIVE_BUDGET_COMMENT = 'primitiveBudget.comment';
export const PRIMITIVE_BUDGET_STATUS = 'primitiveBudget.status';
export const SUPPLEMENTARY_BUDGET = 'supplementaryBudgetInscription';
export const SUPPLEMENTARY_BUDGET_ENDPOINT = 'supplementaryBudgetInscriptions';
export const SUPPLEMENTARY_BUDGET_AMOUNT =
    'supplementaryBudgetInscription.amount';
export const SUPPLEMENTARY_BUDGET_AMOUNT_WITH_REPORT =
    'supplementaryBudgetInscription.amountWithReport';
export const SUPPLEMENTARY_BUDGET_COMMENT =
    'supplementaryBudgetInscription.comment';
export const SUPPLEMENTARY_BUDGET_STATUS =
    'supplementaryBudgetInscription.status';
export const SUPPLEMENTARY_BUDGET_ID = 'supplementaryBudgetInscription.id';
export const INSCRIPTION_ORIGINAL_AMOUNT =
    'inscription.originalInscriptionAmount';
export const INSCRIPTION_ORIGINAL_COMMENT =
    'inscription.originalInscriptionComment';
export const INSCRIPTION_EXERCICE = 'inscription.exercice';
export const INSCRIPTION_EXPENSE_INCOME = 'inscription.expenseIncome';
export const INSCRIPTION_INVESTMENT_OPERATING =
    'inscription.investmentOperating';
export const PROJECT_ID = 'project.id';
export const PROJECT_NAME = 'project.name';
export const PROJECTION_DETAIL_AMOUNT = 'projectionDetails.amount';
export const PROJECTION_DETAIL_COMMENT = 'projectionDetails.comment';
export const PROJECTION_DETAIL_ID = 'projectionDetails.id';
export const PROJECTION_ATTERRISSAGE_STATUS = 'projection.atterrissageStatus';
export const PROJECTION_PLURIANNUAL_STATUS =
    'projection.pluriannualProjectionStatus';
export const PROJECTION_ID = 'projection.id';
export const INSCRIPTION_ID = 'inscription.id';
export const NO_SERVICE = '- PAS DE SERVICE';
export const NO_GESTIONNAIRE = '- PAS DE GESTIONNAIRE';
export const NO_OPERATION_CIRIL_SOFTWARE_ID_VALUE = 'CIVILGF@@';
export const AGG_STATUS = 'aggStatus';
export const ENRICHED_OPERATION_ID = 'enrichedOperation.id';
const BUDGET_LINE_ANALYTIC_POST_1_ID = 'budgetLine.analyticPost1Id';
const BUDGET_LINE_ANALYTIC_POST_2_ID = 'budgetLine.analyticPost2Id';
const BUDGET_LINE_ANALYTIC_POST_3_ID = 'budgetLine.analyticPost3Id';
const BUDGET_LINE_ANALYTIC_POST_4_ID = 'budgetLine.analyticPost4Id';
const BUDGET_LINE_STRAT_FOCUS_ID = 'budgetLine.strategicFocusId';
export const ANALYTIC_POST_0_NAME = 'analyticPost0.name';
export const ANALYTIC_POST_0_CODE = 'analyticPost0.code';
export const ANALYTIC_POST_0_TYPE = 'analyticPost0.type';
export const ANALYTIC_POST_1_NAME = 'analyticPost1.name';
export const ANALYTIC_POST_1_CODE = 'analyticPost1.code';
export const ANALYTIC_POST_1_TYPE = 'analyticPost1.type';
export const ANALYTIC_POST_2_NAME = 'analyticPost2.name';
export const ANALYTIC_POST_2_CODE = 'analyticPost2.code';
export const ANALYTIC_POST_2_TYPE = 'analyticPost2.type';
export const ANALYTIC_POST_3_NAME = 'analyticPost3.name';
export const ANALYTIC_POST_3_CODE = 'analyticPost3.code';
export const ANALYTIC_POST_3_TYPE = 'analyticPost3.type';
export const ANALYTIC_POST_4_NAME = 'analyticPost4.name';
export const ANALYTIC_POST_4_CODE = 'analyticPost4.code';
export const ANALYTIC_POST_4_TYPE = 'analyticPost4.type';
export const ANALYTIC_POST_5_NAME = 'analyticPost5.name';
export const ANALYTIC_POST_5_CODE = 'analyticPost5.code';
export const ANALYTIC_POST_5_TYPE = 'analyticPost5.type';
export const ANALYTIC_POST_6_NAME = 'analyticPost6.name';
export const ANALYTIC_POST_6_CODE = 'analyticPost6.code';
export const ANALYTIC_POST_6_TYPE = 'analyticPost6.type';
export const ANALYTIC_POST_7_NAME = 'analyticPost7.name';
export const ANALYTIC_POST_7_CODE = 'analyticPost7.code';
export const ANALYTIC_POST_7_TYPE = 'analyticPost7.type';
export const ANALYTIC_POST_8_NAME = 'analyticPost8.name';
export const ANALYTIC_POST_8_CODE = 'analyticPost8.code';
export const ANALYTIC_POST_8_TYPE = 'analyticPost8.type';
export const ANALYTIC_POST_9_NAME = 'analyticPost9.name';
export const ANALYTIC_POST_9_CODE = 'analyticPost9.code';
export const ANALYTIC_POST_9_TYPE = 'analyticPost9.type';
export const STRAT_FOCUS_CODE = 'strategicFocus.code';
export const STRAT_FOCUS_NAME = 'strategicFocus.name';
const BUDGET_LINE_AP_ASSIGNMENT_ID = 'budgetLine.apAssignmentId';
export const AP_CODE = 'ap.code';
export const AP_LABEL = 'ap.label';
export const AP_START_YEAR = 'ap.startYear';
const BUDGET_LINE_OPERATION_SEGMENT_ID = 'budgetLine.operationSegmentId';
export const OPERATION_SEGMENT_CODE = 'operationSegment.code';
export const OPERATION_SEGMENT_NAME = 'operationSegment.name';
export const OPERATION_SEGMENT_SOFTWARE_ID = 'operationSegment.softwareId';
export const COMMENT = 'comment';
export const AMOUNT = 'amount';
export const STATUS = 'status';

/**
 * Specific to AMP, the operation segment is budgetable if it's a "mother" operation, meaning it doesn't have a "parent_software_id"
 * Other Sedit Finances customers may have the same principle for other fields like nature, so we'll need to refactor this when we'll
 * be more confident on the right way to do it
 */
export const IS_AMPMETROPOLE_BUDGETABLE = 'isAmpmetropoleBudgetable';

const BUDGET_LINE_ANALYTIC_NATURE_ID = 'budgetLine.analyticNatureId';
export const ANALYTIC_NATURE_SOFTWARE_ID = 'analyticNature.softwareId';
export const ANALYTIC_NATURE_CODE = 'analyticNature.code';
export const ANALYTIC_NATURE_NAME = 'analyticNature.name';

const BUDGET_LINE_SUB_FUNCTION_ID = 'budgetLine.subFunctionId';
export const SUB_FUNCTION_NUMBER = 'subFunction.number';
export const SUB_FUNCTION_LABEL = 'subFunction.label';

const BUDGET_LINE_ENVELOPPE_ID = 'budgetLine.enveloppeId';
export const ENVELOPPE_SOFTWARE_ID = 'enveloppe.softwareId';
export const ENVELOPPE_CODE = 'enveloppe.code';
export const ENVELOPPE_LABEL = 'enveloppe.label';

export const BUDGET_LINE_ENVELOPPE_VENTILATION_CODE =
    'budgetLine.enveloppeVentilationCode';
export const BUDGET_LINE_OPERATION_VENTILATION_CODE =
    'budgetLine.operationVentilationCode';

const BUDGET_LINE_BUDGET_LINE_PROGRAM_ID = 'budgetLine.budgetLineProgramId';
export const BUDGET_LINE_PROGRAM_SOFTWARE_ID = 'budgetLineProgram.softwareId';
export const BUDGET_LINE_PROGRAM_CODE = 'budgetLineProgram.code';
export const BUDGET_LINE_PROGRAM_NAME = 'budgetLineProgram.name';

export const INSCRIPTION_ID_URL_PARAM = 'inscription_id';

export const BUDGET_PROPOSAL_VIEW_BY = 'viewBy';
export const BUDGET_PROPOSAL_VENTILATION_BY_RESOURCE = 'resource';
export const BUDGET_PROPOSAL_VENTILATION_BY_OPERATION = 'operation';
export const FINANCE_SCOPE = 'default_finance';

// Budget Edition metadata
export const IN_WRITE_SCOPE = 'inWriteScope';
export const IS_PHASE_EDITABLE = 'isPhaseEditable';
export const IS_PHASE_MOVABLE = 'isPhaseMovable';
export const IS_REJECTED = 'isRejected';
export const IS_EDITION_OPEN_TO_RESOURCE = 'isEditionOpenToResource';
export const CAN_MOVE = 'canMove';
export const CAN_EDIT = 'canEdit';
export const CAN_ADD_INSCRIPTION = 'canAddInscription';

// csv export fields for SIFAC
const SIFAC_ORG_CHART_FINANCE_CODE = 'Centre financier';
const SIFAC_OPERATION_CODE = 'PFI';
const SIFAC_INSCRIPTION_EXERCICE = 'Exercice';
const SIFAC_BUDGET_LINE_CODE = 'Catégorie Budgétaire';
const SIFAC_FUNCTION_NUMBER = 'Domaine fonctionnel';
const SIFAC_CHAPTER_CODE = 'Compte budgétaire';
const SIFAC_NATURE_CODE = 'Fonds';
const SIFAC_BUDGET_TYPE = 'Type de budget';
const SIFAC_TEXT = 'texte';
const SIFAC_VERSION = 'Version';
const SIFAC_PIECE_TYPE = 'Type de pièces';
const SIFAC_INSCRIPTION_AMOUNT = 'montant';
const SIFAC_INSCRIPTION_COMMENT = 'Libellé';

// csv extra fields for ASTRE_GF
const ASTRE_COLLECTIVITY_CODE = 'COD_COLL';
const ASTRE_EXERCICE_NUMBER = 'NUM_EXBUDG';
const ASTRE_BUDGET_CODE = 'COD_BUDG';
const ASTRE_BUDGET_LINE_CODE = 'NUM_ENV';
const ASTRE_INSCRIPTION_PHASE_TYPE = 'TYP_PREV';
const ASTRE_NUM_DM = 'NUM_DM';
const ASTRE_NIV_PRO = 'NIV_PRO';
const ASTRE_CHAPTER_CODE = 'NUM_CHAP';
const ASTRE_NUM_SCHAP = 'NUM_SCHAP';
const ASTRE_NATURE_CODE = 'NUM_ART';
const ASTRE_NUM_PRG = 'NUM_PRG';
const ASTRE_EXPENSE_INCOME = 'TYP_MVT';
const ASTRE_REAL_ORDER = 'COD_NATURE';
const ASTRE_CODE_SECTION = 'COD_SECTION';
const ASTRE_INSCRIPTION_COMMENT = 'LIB_PREV';
const ASTRE_INSCRIPTION_AMOUNT = 'MNT_PREV';
const ASTRE_MNT_HYP2_PREV = 'MNT_HYP2_PREV';
const ASTRE_MNT_HYP3_PREV = 'MNT_HYP3_PREV';
const ASTRE_IDENT_INT = 'IDENT_INT';
const ASTRE_NUM_ENR = 'NUM_ENR';
const ASTRE_IND_NIV_TRAIT = 'IND_NIV_TRAIT';
const ASTRE_IND_VALID = 'IND_VALID';
const ASTRE_OPERATION_CODE = 'Opération';

// CSV extra fields for JVS_FINANCES
const JVS_VOTE = 'VOTE';
const JVS_REPORT = 'REPORT';
const JVS_PRIMITIVE_N1 = 'JVS_PRIMITIVE_N1';
const JVS_SUPP_N1 = 'JVS_SUPP_N1';
const JVS_MOD_N1 = 'JVS_MOD_N1';
const JVS_CUM_N1 = 'JVS_CUM_N1';
const JVS_REAL_N1 = 'JVS_REAL_N1';
const JVS_AVAI_N1 = 'JVS_AVAI_N1';
const JVS_PRIMITIVE = 'JVS_PRIMITIVE';
const JVS_MOD = 'JVS_MOD';
const JVS_CUM = 'JVS_CUM';
const JVS_REAL = 'JVS_REAL';
const JVS_AVAI = 'JVS_AVAI';

// CSV extra fields for SEDIT_FINANCES
const SEDIT_PROPOSE_AP = 'SEDIT_PROPOSE_AP';
const SEDIT_PROPOSE_CP = 'SEDIT_PROPOSE_CP';
const SEDIT_VOTE_AP = 'SEDIT_VOTE_AP';
const SEDIT_REPORTE_CP = 'SEDIT_REPORTE_CP';

const SIFAC_CSV_TRANSLATIONS: Record<string, string> = {
    [ORG_CHART_FINANCE_CODE_FIELD]: SIFAC_ORG_CHART_FINANCE_CODE,
    [OPERATION_FIELD]: SIFAC_OPERATION_CODE,
    [INSCRIPTION_EXERCICE]: SIFAC_INSCRIPTION_EXERCICE,
    [LINE_CODE_FIELD]: SIFAC_BUDGET_LINE_CODE,
    [FUNCTION_FIELD]: SIFAC_FUNCTION_NUMBER,
    [CHAPTER_FIELD]: SIFAC_CHAPTER_CODE,
    [NATURE_FIELD]: SIFAC_NATURE_CODE,
    [SERVICE_PROPOSAL_AMOUNT]: SIFAC_INSCRIPTION_AMOUNT,
    [SIMULATED_ARBITRATED_AMOUNT]: SIFAC_INSCRIPTION_AMOUNT,
    [PRIMITIVE_BUDGET_AMOUNT]: SIFAC_INSCRIPTION_AMOUNT,
    [SUPPLEMENTARY_BUDGET_AMOUNT]: SIFAC_INSCRIPTION_AMOUNT,
    [SERVICE_PROPOSAL_COMMENT]: SIFAC_INSCRIPTION_COMMENT,
    [SIMULATED_COMMENT]: SIFAC_INSCRIPTION_COMMENT,
    [PRIMITIVE_BUDGET_COMMENT]: SIFAC_INSCRIPTION_COMMENT,
    [SUPPLEMENTARY_BUDGET_COMMENT]: SIFAC_INSCRIPTION_COMMENT,
    [SIFAC_BUDGET_TYPE]: SIFAC_BUDGET_TYPE,
    [SIFAC_TEXT]: SIFAC_TEXT,
    [SIFAC_VERSION]: SIFAC_VERSION,
    [SIFAC_PIECE_TYPE]: SIFAC_PIECE_TYPE,
};

const ASTRE_GF_TRANSLATIONS: Record<string, string> = {
    [ASTRE_COLLECTIVITY_CODE]: ASTRE_COLLECTIVITY_CODE,
    [INSCRIPTION_EXERCICE]: ASTRE_EXERCICE_NUMBER,
    [BUDGET_CODE_FIELD]: ASTRE_BUDGET_CODE,
    [LINE_CODE_FIELD]: ASTRE_BUDGET_LINE_CODE,
    [ASTRE_INSCRIPTION_PHASE_TYPE]: ASTRE_INSCRIPTION_PHASE_TYPE,
    [ASTRE_NUM_DM]: ASTRE_NUM_DM,
    [ASTRE_NIV_PRO]: ASTRE_NIV_PRO,
    [ASTRE_CHAPTER_CODE]: ASTRE_CHAPTER_CODE,
    [ASTRE_NUM_SCHAP]: ASTRE_NUM_SCHAP,
    [NATURE_FIELD]: ASTRE_NATURE_CODE,
    [ASTRE_NUM_PRG]: ASTRE_NUM_PRG,
    [ASTRE_EXPENSE_INCOME]: ASTRE_EXPENSE_INCOME,
    [ASTRE_REAL_ORDER]: ASTRE_REAL_ORDER,
    [ASTRE_CODE_SECTION]: ASTRE_CODE_SECTION,
    [ASTRE_INSCRIPTION_COMMENT]: ASTRE_INSCRIPTION_COMMENT,
    [SERVICE_PROPOSAL_AMOUNT]: ASTRE_INSCRIPTION_AMOUNT,
    [SIMULATED_ARBITRATED_AMOUNT]: ASTRE_INSCRIPTION_AMOUNT,
    [PRIMITIVE_BUDGET_AMOUNT]: ASTRE_INSCRIPTION_AMOUNT,
    [SUPPLEMENTARY_BUDGET_AMOUNT]: ASTRE_INSCRIPTION_AMOUNT,
    [VOTED_FIELD]: ASTRE_INSCRIPTION_AMOUNT,
    [ASTRE_MNT_HYP2_PREV]: ASTRE_MNT_HYP2_PREV,
    [ASTRE_MNT_HYP3_PREV]: ASTRE_MNT_HYP3_PREV,
    [ASTRE_IDENT_INT]: ASTRE_IDENT_INT,
    [ASTRE_NUM_ENR]: ASTRE_NUM_ENR,
    [ASTRE_IND_NIV_TRAIT]: ASTRE_IND_NIV_TRAIT,
    [ASTRE_IND_VALID]: ASTRE_IND_VALID,
    [OPERATION_FIELD]: ASTRE_OPERATION_CODE,
};

const JVS_FINANCES_TRANSLATIONS: Record<string, string> = {
    [INSCRIPTION_INVESTMENT_OPERATING]: 'Section',
    [NATURE_FIELD]: 'Article',
    [NATURE_LABEL_FIELD]: 'Libellé Article',
    [INSCRIPTION_EXPENSE_INCOME]: 'Sens',
    [CHAPTER_FIELD]: 'Chapitre',
    [CHAPTER_LABEL_FIELD]: 'Libellé Chapitre',
    [FUNCTION_FIELD]: 'Fonction',
    [OPERATION_FIELD]: 'Opération',
    [OPERATION_NAME_FIELD]: 'Libellé Opération',
    [FUNCTION_LABEL_FIELD]: 'Libellé Fonction',
    [GESTIONNAIRE_CODE_FIELD]: 'Service utilisateur',
    [ANALYTIC_FIELD]: 'Compte Analytique',
    [ANALYTIC_NAME_FIELD]: 'Libellé Compte Analytique',
    [JVS_VOTE]: 'Vote',
    [JVS_PRIMITIVE]: 'Budget Primitif',
    [JVS_PRIMITIVE_N1]: 'Budget Primitif N-1',
    [JVS_SUPP_N1]: 'Budget Supplémentaire N-1',
    [JVS_MOD_N1]: 'Décisions Modificatives N-1',
    [JVS_CUM_N1]: 'Budget Cumulé N-1',
    [JVS_REAL_N1]: 'Réalisations N-1',
    [JVS_AVAI_N1]: 'Disponible N-1',
    [JVS_MOD]: 'Décisions Modificatives',
    [JVS_CUM]: 'Budget Cumulé',
    [JVS_REAL]: 'Réalisations',
    [JVS_AVAI]: 'Disponible',
    [JVS_REPORT]: 'Report',
    [SERVICE_PROPOSAL_AMOUNT]: 'Prop',
    [SIMULATED_ARBITRATED_AMOUNT]: 'Prop',
    [PRIMITIVE_BUDGET_AMOUNT]: 'Prop',
    [SUPPLEMENTARY_BUDGET_AMOUNT]: 'Prop',
};

const SEDIT_CSV_TRANSLATIONS: Record<string, string> = {
    [INSCRIPTION_EXPENSE_INCOME]: 'Sens',
    [INSCRIPTION_INVESTMENT_OPERATING]: 'Section',
    [AP_START_YEAR]: 'Millesime',
    [AP_CODE]: 'AP/AE',
    [CHAPTER_FIELD]: 'Chapitre par nature',
    [NATURE_FIELD]: 'Article par nature',
    [FUNCTION_FIELD]: 'Référence Fonctionnelle',
    [GESTIONNAIRE_CODE_FIELD]: 'Service Gestionnaire',
    [ORG_CHART_FINANCE_CODE_FIELD]: 'Service Destinataire',
    [OPERATION_FIELD]: "Opération d'équipement",
    [ANALYTIC_POST_1_CODE]: 'Segmentation Sectorielle 1',
    [ANALYTIC_POST_2_CODE]: 'Segmentation Sectorielle 2',
    [ANALYTIC_POST_3_CODE]: 'Segmentation Sectorielle 3',
    [ANALYTIC_POST_4_CODE]: 'Segmentation Sectorielle 4',
    [STRAT_FOCUS_CODE]: 'Segmentation Stratégique',
    [OPERATION_SEGMENT_CODE]: 'Segmentation Opérationnelle',
    [SERVICE_PROPOSAL_AMOUNT]: 'Voté CP',
    [SIMULATED_ARBITRATED_AMOUNT]: 'Voté CP',
    [PRIMITIVE_BUDGET_AMOUNT]: 'Voté CP',
    [SUPPLEMENTARY_BUDGET_AMOUNT]: 'Voté CP',
    [SEDIT_PROPOSE_AP]: 'Proposé AP',
    [SEDIT_PROPOSE_CP]: 'Proposé CP',
    [SEDIT_VOTE_AP]: 'Voté AP',
    [SEDIT_REPORTE_CP]: 'Reporté CP CP',
    [REAL_ORDER_FIELD]: 'Type de mouvement',
    [LINE_CODE_FIELD]: 'Imputation',
};

const OP_PROG_GRAND_ANGLE_INTERNAL_ID = 'OP_PROG_GRAND_ANGLE_INTERNAL_ID';
const GESTIONNAIRE_LABEL_WITHOUT_CODE = 'GESTIONNAIRE_LABEL_WITHOUT_CODE';
export const SBA_LABEL_WITHOUT_CODE = 'SBA_LABEL_WITHOUT_CODE';
const ENVELOPPE_GRAND_ANGLE_INTERNAL_ID = 'ENVELOPPE_GRAND_ANGLE_INTERNAL_ID';
const OP_PG = 'OP/PG';
const ANALYTIC_NATURE_LABEL_WITHOUT_CODE = 'ANALYTIC_NATURE_LABEL_WITHOUT_CODE';
const IMPUTATION = 'IMPUTATION';

const GRAND_ANGLE_TRANSLATIONS: Record<string, string> = {
    /* FIXME: I'm sorry, just another layer of shit on the cathedral of feces that is
     * the Excel export code for now. */
    [SECONDARY_BUDGET_AXIS_ELEMENT_CODE]:
        'THIS IS OVERRIDEN IN translateColHeader',
    [OP_PROG_GRAND_ANGLE_INTERNAL_ID]: '',
    [GESTIONNAIRE_LABEL_WITHOUT_CODE]: 'CdR Gestionnaire',
    [GESTIONNAIRE_CODE_FIELD]: '',
    [SBA_LABEL_WITHOUT_CODE]: 'THIS IS OVERRIDEN IN translateColHeader',
    [ENVELOPPE_CODE]: 'AP/EPCP',
    [ENVELOPPE_GRAND_ANGLE_INTERNAL_ID]: '',
    [OP_PG]: '',
    [BUDGET_LINE_OPERATION_VENTILATION_CODE]: '',
    [BUDGET_LINE_ENVELOPPE_VENTILATION_CODE]: '',
    [ANALYTIC_NATURE_CODE]: 'Code Nature Analytique',
    [ANALYTIC_NATURE_LABEL_WITHOUT_CODE]: 'Description Nature Analytique',
    [IMPUTATION]: 'Imputation',
    [SERVICE_PROPOSAL_AMOUNT]: 'Montant',
    [SIMULATED_ARBITRATED_AMOUNT]: 'Montant',
    [PRIMITIVE_BUDGET_AMOUNT]: 'Montant',
    [SUPPLEMENTARY_BUDGET_AMOUNT]: 'Montant',
};

/*
    CSV_HEADER_CUSTOM_TRANSLATION allows overriding translation from i18n translations
    or adding extra translations used for CUSTOM export
*/
export const CSV_HEADER_CUSTOM_TRANSLATION: Record<
    string,
    Record<string, string>
> = {
    SIFAC: SIFAC_CSV_TRANSLATIONS,
    SEDIT_FINANCES_GFDE: SEDIT_CSV_TRANSLATIONS,
    SEDIT_FINANCES: SEDIT_CSV_TRANSLATIONS,
    ASTRE_GF: ASTRE_GF_TRANSLATIONS,
    JVS_FINANCES: JVS_FINANCES_TRANSLATIONS,
    GRAND_ANGLE: GRAND_ANGLE_TRANSLATIONS,
};

export const FUNCTION_BUDGET_PHASE_COLORS = {
    color: {
        [BudgetPhases.CADRAGE]: MANTY_ORANGE,
        [BudgetPhases.PROPOSITION_SERVICES]: MANTY_CYAN,
        [BudgetPhases.ARBITRAGE]: '#542BAB',
        [BudgetPhases.VOTE]: '#388866',
        [BudgetPhases.SUPPLEMENTARY_BUDGET]: '#163066',
        [BudgetPhases.ARCHIVED]: MANTY_BLACK,
    },
    background: {
        [BudgetPhases.CADRAGE]: 'rgba(233, 129, 95, 0.15)',
        [BudgetPhases.PROPOSITION_SERVICES]: 'rgba(3, 110, 187, 0.15)',
        [BudgetPhases.ARBITRAGE]: 'rgba(84, 43, 171, 0.15)',
        [BudgetPhases.VOTE]: 'rgba(56, 136, 102, 0.15)',
        [BudgetPhases.SUPPLEMENTARY_BUDGET]: 'rgba(3, 33, 91, 0.25)',
        [BudgetPhases.ARCHIVED]: '#d4d3d3',
    },
} as const;

export const DIVIDED_IMPUTATIONS_COLUMN_FIELDS: {
    [key: string]: readonly (keyof InscriptionT)[];
} = {
    DEFAULT: [
        BUDGET_NAME_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        OPERATION_NAME_FIELD,
    ],
    ASTRE_GF: [
        BUDGET_NAME_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        LINE_NAME_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        OPERATION_NAME_FIELD,
    ],
    CIRIL_FINANCES: [
        BUDGET_NAME_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        ANTENNA_NAME_FIELD,
        OPERATION_NAME_FIELD,
    ],
    JVS_FINANCES: [
        BUDGET_NAME_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        ANALYTIC_FIELD,
        OPERATION_NAME_FIELD,
    ],
    SEDIT_FINANCES: [
        BUDGET_NAME_FIELD,
        GESTIONNAIRE_CODE_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        DIRECTION_LABEL,
        ANALYTIC_FIELD,
        OPERATION_NAME_FIELD,
    ],
    SEDIT_FINANCES_GFDE: [
        BUDGET_NAME_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        ANALYTIC_FIELD,
        OPERATION_NAME_FIELD,
    ],
    SEGILOG: [
        BUDGET_NAME_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        OPERATION_NAME_FIELD,
    ],
    SIFAC: [
        BUDGET_NAME_FIELD,
        REAL_ORDER_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        OPERATION_NAME_FIELD,
        ANALYTIC_NAME_FIELD,
        BUDGET_LINE_CODE,
    ],
    GRAND_ANGLE: [
        BUDGET_NAME_FIELD,
        INSCRIPTION_INVESTMENT_OPERATING,
        REAL_ORDER_FIELD,
        GESTIONNAIRE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_LABEL_FIELD,
        FUNCTION_LABEL_FIELD,
        SUB_FUNCTION_LABEL_FIELD,
        OPERATION_NAME_FIELD,
        ANALYTIC_NAME_FIELD,
        BUDGET_LINE_PROGRAM_NAME,
        BUDGET_LINE_PROGRAM_CODE,
        ENVELOPPE_LABEL,
        ENVELOPPE_CODE,
        ANALYTIC_NATURE_NAME,
        ANALYTIC_NATURE_CODE,
    ],
} as const;

export const dimToPivotInRequest = BUDGET_YEAR_FIELD;

export const CADRAGE = 'cadrage';
export const DEPASSEMENT_METRIC = 'depassement';

export const EVOLUTION_N_N_1 = 'evolution';

export enum VIEW_DETAILS {
    VIEW = 'view',
    CONSULT = 'consulter',
}

export const ANALYSE_PIVOT_TABLE_TO_HIDE_BY_DEFAULT = [
    SUPER_GESTIONNAIRE_NAME_FIELD,
    GESTIONNAIRE_CODE_FIELD,
    FUNCTION_FIELD,
    FUNCTION_LABEL_FIELD,
    ANTENNA_FIELD,
    ANTENNA_NAME_FIELD,
    OPERATION_FIELD,
    OPERATION_NAME_FIELD,
    NATURE_LABEL_FIELD,
    CHAPTER_FIELD,
    CHAPTER_LABEL_FIELD,
    ORG_CHART_FINANCE_FIELD,
    BUDGET_NAME_FIELD,
    AMOUNT_ENGAGED_UNPAID,
    BUDGET_LINE_PROGRAM_CODE,
    BUDGET_LINE_PROGRAM_NAME,
    ENVELOPPE_CODE,
    ENVELOPPE_LABEL,
    ANALYTIC_NATURE_CODE,
    ANALYTIC_NATURE_NAME,
    DIRECTION_CODE,
    DIRECTION_LABEL,
] as const;

export const COMMON_INSCRIPION_COLUMNS_TO_EXPORT = {
    JVS_FINANCES: [
        INSCRIPTION_INVESTMENT_OPERATING,
        INSCRIPTION_EXPENSE_INCOME,
        CHAPTER_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_FIELD,
        NATURE_LABEL_FIELD,
        OPERATION_FIELD,
        OPERATION_NAME_FIELD,
        FUNCTION_FIELD,
        FUNCTION_LABEL_FIELD,
        GESTIONNAIRE_CODE_FIELD,
        ORG_CHART_FINANCE_FIELD,
        ANALYTIC_FIELD,
        ANALYTIC_NAME_FIELD,
    ],
    CIRIL_FINANCES: [
        BUDGET_CODE_FIELD,
        INSCRIPTION_EXERCICE,
        BUDGET_LINE_INSCRIPTION_STEP,
        INSCRIPTION_EXPENSE_INCOME,
        GESTIONNAIRE_CODE_FIELD,
        ORG_CHART_FINANCE_CODE_FIELD,
        CHAPTER_FIELD,
        NATURE_FIELD,
        FUNCTION_FIELD,
        ANTENNA_FIELD,
        OPERATION_FIELD,
    ],
    SEDIT_FINANCES: [
        INSCRIPTION_EXPENSE_INCOME,
        INSCRIPTION_INVESTMENT_OPERATING,
        AP_START_YEAR,
        AP_CODE,
        CHAPTER_FIELD,
        NATURE_FIELD,
        FUNCTION_FIELD,
        GESTIONNAIRE_CODE_FIELD,
        OPERATION_FIELD,
        ANALYTIC_POST_1_CODE,
        ANALYTIC_POST_2_CODE,
        ANALYTIC_POST_3_CODE,
        STRAT_FOCUS_CODE,
        OPERATION_SEGMENT_CODE,
        ORG_CHART_FINANCE_CODE_FIELD,
        ANALYTIC_POST_4_CODE,
        REAL_ORDER_FIELD,
        LINE_CODE_FIELD,
    ],
    SEDIT_FINANCES_GFDE: [
        INSCRIPTION_EXPENSE_INCOME,
        INSCRIPTION_INVESTMENT_OPERATING,
        AP_START_YEAR,
        AP_CODE,
        CHAPTER_FIELD,
        NATURE_FIELD,
        FUNCTION_FIELD,
        GESTIONNAIRE_CODE_FIELD,
        OPERATION_FIELD,
        STRAT_FOCUS_CODE,
        OPERATION_SEGMENT_CODE,
        ORG_CHART_FINANCE_CODE_FIELD,
        REAL_ORDER_FIELD,
        ANALYTIC_FIELD,
        SUB_NATURE_FIELD,
    ],
    SIFAC: [
        INSCRIPTION_EXERCICE,
        LINE_CODE_FIELD,
        ORG_CHART_FINANCE_CODE_FIELD,
        OPERATION_FIELD,
        CHAPTER_FIELD,
        FUNCTION_FIELD,
        NATURE_FIELD,
    ],
    ASTRE_GF: [
        INSCRIPTION_EXERCICE,
        BUDGET_CODE_FIELD,
        LINE_CODE_FIELD,
        NATURE_FIELD,
        OPERATION_FIELD, // actually not managed by ASTRE GF, but Haguenau wants it
        BUDGET_NAME_FIELD, // used for the COD_COLL column
        REAL_ORDER_FIELD, // used by an additional formatting
        INSCRIPTION_EXPENSE_INCOME, // used by an additional formatting
        INSCRIPTION_INVESTMENT_OPERATING,
    ],
    GRAND_ANGLE: [
        // most columns for Grand Angle are customized in EXTRA_COLUMNS_TO_EXPORT,
        // we should have an ag-grid like col def design for Excel export, where everything
        // is explicitely defined for each column in one place.
        SECONDARY_BUDGET_AXIS_ELEMENT_CODE,
        ENVELOPPE_CODE,
    ],
};

export const LABEL_CIRIL_EXTRA_COLUMN = {
    label: 'Libellé',
    key: 'label',
};
export const LABEL_CIRIL_EXTRA_COLUMN_REIMPORT = {
    label: 'Observation',
    key: 'observation',
};

// it defines the final expected column in order for the CSV export per software
// it is used to sort the column by order and pops any data that is not in this list
export const COMMON_INSCRIPTION_COLUMNS_ORDER_FILTER_TO_EXPORT = {
    CIRIL_FINANCES: [
        ...COMMON_INSCRIPION_COLUMNS_TO_EXPORT.CIRIL_FINANCES,
        SERVICE_PROPOSAL_AMOUNT,
        SIMULATED_ARBITRATED_AMOUNT,
        PRIMITIVE_BUDGET_AMOUNT,
        SUPPLEMENTARY_BUDGET_AMOUNT,
        LABEL_CIRIL_EXTRA_COLUMN.key,
        LABEL_CIRIL_EXTRA_COLUMN_REIMPORT.key,
        SERVICE_PROPOSAL_COMMENT,
        SIMULATED_COMMENT,
        PRIMITIVE_BUDGET_COMMENT,
        SUPPLEMENTARY_BUDGET_COMMENT,
    ],
    SIFAC: [
        ORG_CHART_FINANCE_CODE_FIELD,
        CHAPTER_FIELD,
        OPERATION_FIELD,
        FUNCTION_FIELD,
        NATURE_FIELD,
        LINE_CODE_FIELD,
        SIFAC_BUDGET_TYPE,
        SIFAC_VERSION,
        SIFAC_PIECE_TYPE,
        INSCRIPTION_EXERCICE,
        SERVICE_PROPOSAL_AMOUNT,
        SIMULATED_ARBITRATED_AMOUNT,
        PRIMITIVE_BUDGET_AMOUNT,
        SUPPLEMENTARY_BUDGET_AMOUNT,
        SIFAC_TEXT,
    ],
    ASTRE_GF: [
        ASTRE_COLLECTIVITY_CODE,
        INSCRIPTION_EXERCICE,
        BUDGET_CODE_FIELD,
        LINE_CODE_FIELD,
        ASTRE_INSCRIPTION_PHASE_TYPE,
        ASTRE_NUM_DM,
        ASTRE_NIV_PRO,
        ASTRE_CHAPTER_CODE,
        ASTRE_NUM_SCHAP,
        NATURE_FIELD,
        ASTRE_NUM_PRG,
        ASTRE_EXPENSE_INCOME,
        ASTRE_REAL_ORDER,
        ASTRE_CODE_SECTION,
        ASTRE_INSCRIPTION_COMMENT,
        SERVICE_PROPOSAL_AMOUNT,
        SIMULATED_ARBITRATED_AMOUNT,
        PRIMITIVE_BUDGET_AMOUNT,
        SUPPLEMENTARY_BUDGET_AMOUNT,
        ASTRE_MNT_HYP2_PREV,
        ASTRE_MNT_HYP3_PREV,
        ASTRE_IDENT_INT,
        ASTRE_NUM_ENR,
        ASTRE_IND_NIV_TRAIT,
        ASTRE_IND_VALID,
        ASTRE_OPERATION_CODE,
        OPERATION_FIELD,
    ],
    JVS_FINANCES: [
        INSCRIPTION_INVESTMENT_OPERATING,
        INSCRIPTION_EXPENSE_INCOME,
        CHAPTER_FIELD,
        CHAPTER_LABEL_FIELD,
        NATURE_FIELD,
        NATURE_LABEL_FIELD,
        OPERATION_FIELD,
        OPERATION_NAME_FIELD,
        FUNCTION_FIELD,
        FUNCTION_LABEL_FIELD,
        ANALYTIC_FIELD,
        ANALYTIC_NAME_FIELD,
        GESTIONNAIRE_CODE_FIELD,
        JVS_PRIMITIVE,
        SERVICE_PROPOSAL_AMOUNT,
        SIMULATED_ARBITRATED_AMOUNT,
        PRIMITIVE_BUDGET_AMOUNT,
        SUPPLEMENTARY_BUDGET_AMOUNT,
        JVS_VOTE,
        JVS_REPORT,
        JVS_PRIMITIVE_N1,
        JVS_SUPP_N1,
        JVS_MOD_N1,
        JVS_CUM_N1,
        JVS_REAL_N1,
        JVS_AVAI_N1,
        JVS_MOD,
        JVS_CUM,
        JVS_REAL,
        JVS_AVAI,
    ],
    SEDIT_FINANCES: [
        INSCRIPTION_EXPENSE_INCOME,
        INSCRIPTION_INVESTMENT_OPERATING,
        AP_START_YEAR,
        AP_CODE,
        CHAPTER_FIELD,
        NATURE_FIELD,
        FUNCTION_FIELD,
        GESTIONNAIRE_CODE_FIELD,
        OPERATION_FIELD,
        ANALYTIC_POST_1_CODE,
        ANALYTIC_POST_2_CODE,
        ANALYTIC_POST_3_CODE,
        STRAT_FOCUS_CODE,
        OPERATION_SEGMENT_CODE,
        ORG_CHART_FINANCE_CODE_FIELD,
        ANALYTIC_POST_4_CODE,
        SEDIT_PROPOSE_AP,
        SEDIT_PROPOSE_CP,
        SEDIT_VOTE_AP,
        SERVICE_PROPOSAL_AMOUNT,
        SIMULATED_ARBITRATED_AMOUNT,
        PRIMITIVE_BUDGET_AMOUNT,
        SUPPLEMENTARY_BUDGET_AMOUNT,
        SEDIT_REPORTE_CP,
        REAL_ORDER_FIELD,
        LINE_CODE_FIELD,
    ],
    SEDIT_FINANCES_GFDE: [
        INSCRIPTION_EXPENSE_INCOME,
        INSCRIPTION_INVESTMENT_OPERATING,
        AP_START_YEAR,
        AP_CODE,
        CHAPTER_FIELD,
        NATURE_FIELD,
        FUNCTION_FIELD,
        GESTIONNAIRE_CODE_FIELD,
        OPERATION_FIELD,
        STRAT_FOCUS_CODE,
        OPERATION_SEGMENT_CODE,
        ORG_CHART_FINANCE_CODE_FIELD,
        SEDIT_PROPOSE_AP,
        SEDIT_PROPOSE_CP,
        SEDIT_VOTE_AP,
        SERVICE_PROPOSAL_AMOUNT,
        SIMULATED_ARBITRATED_AMOUNT,
        PRIMITIVE_BUDGET_AMOUNT,
        SUPPLEMENTARY_BUDGET_AMOUNT,
        SEDIT_REPORTE_CP,
        REAL_ORDER_FIELD,
        ANALYTIC_FIELD,
        SUB_NATURE_FIELD,
    ],
    GRAND_ANGLE: [
        SECONDARY_BUDGET_AXIS_ELEMENT_CODE,
        OP_PROG_GRAND_ANGLE_INTERNAL_ID,
        GESTIONNAIRE_LABEL_WITHOUT_CODE,
        GESTIONNAIRE_CODE_FIELD,
        SBA_LABEL_WITHOUT_CODE,
        ENVELOPPE_CODE,
        ENVELOPPE_GRAND_ANGLE_INTERNAL_ID,
        OP_PG,
        BUDGET_LINE_OPERATION_VENTILATION_CODE,
        BUDGET_LINE_ENVELOPPE_VENTILATION_CODE,
        ANALYTIC_NATURE_CODE,
        ANALYTIC_NATURE_LABEL_WITHOUT_CODE,
        IMPUTATION,
        SERVICE_PROPOSAL_AMOUNT,
        SIMULATED_ARBITRATED_AMOUNT,
        PRIMITIVE_BUDGET_AMOUNT,
        SUPPLEMENTARY_BUDGET_AMOUNT,
    ],
};

const removeFieldPrefix = (
    fieldPrefix: keyof InscriptionT,
    field: keyof InscriptionT,
    data: InscriptionT,
): string => {
    const value = data[field];
    const prefix = data[fieldPrefix];
    if (typeof value !== 'string' || typeof prefix !== 'string') {
        return `${value}`;
    }
    const matched = value.match(new RegExp(`${prefix} - (.+)`));
    return matched ? matched[1] : value;
};

export const createExtraColumn = (
    partialColumn: Omit<ExtraColumn, 'label' | 'type'>,
): ExtraColumn => {
    return {
        label: '',
        type: 'text',
        ...partialColumn,
    };
};

const CIRIL_LIBELLE_COLUMN_MAX_LENGTH = 60;

export type ActiveBudgetCommentFields =
    | typeof SIMULATED_COMMENT
    | typeof SERVICE_PROPOSAL_COMMENT
    | typeof PRIMITIVE_BUDGET_COMMENT
    | typeof SUPPLEMENTARY_BUDGET_COMMENT;

export const phasesWithCommentField: Record<
    ActiveBudgetPhases,
    ActiveBudgetCommentFields
> = {
    [BudgetPhases.ARBITRAGE]: SIMULATED_COMMENT,
    [BudgetPhases.PROPOSITION_SERVICES]: SERVICE_PROPOSAL_COMMENT,
    [BudgetPhases.VOTE]: PRIMITIVE_BUDGET_COMMENT,
    [BudgetPhases.SUPPLEMENTARY_BUDGET]: SUPPLEMENTARY_BUDGET_COMMENT,
};

// FIXME: it's hacky, it's ugly, I had to do it in a rush
export const EXTRA_COLUMNS_FOR_REIMPORT: Record<string, ExtraColumn[]> = {
    CIRIL: [
        {
            label: LABEL_CIRIL_EXTRA_COLUMN_REIMPORT.label,
            key: LABEL_CIRIL_EXTRA_COLUMN_REIMPORT.key,
            type: 'text',
            getValue: (data: InscriptionT, phase: BudgetPhases) => {
                if (
                    !Object.prototype.hasOwnProperty.call(
                        phasesWithCommentField,
                        phase,
                    )
                ) {
                    return '';
                }
                const commentField =
                    phasesWithCommentField[phase as ActiveBudgetPhases];

                return data?.[commentField] || '';
            },
        },
    ],
};
export const EXTRA_COLUMNS_TO_EXPORT: Record<string, ExtraColumn[]> = {
    CIRIL: [
        {
            label: LABEL_CIRIL_EXTRA_COLUMN.label,
            key: LABEL_CIRIL_EXTRA_COLUMN.key,
            type: 'text',
            getValue: (data: InscriptionT, phase: BudgetPhases) => {
                if (
                    !Object.prototype.hasOwnProperty.call(
                        phasesWithCommentField,
                        phase,
                    )
                ) {
                    return '';
                }
                const commentField =
                    phasesWithCommentField[phase as ActiveBudgetPhases];
                return (
                    data?.[commentField]?.slice(
                        0,
                        CIRIL_LIBELLE_COLUMN_MAX_LENGTH,
                    ) ?? ''
                );
            },
        },
    ],
    SIFAC: [
        createExtraColumn({
            key: SIFAC_BUDGET_TYPE,
            getValue: () => 'BI',
        }),
        createExtraColumn({
            key: SIFAC_TEXT,
            getValue: (data: InscriptionT) =>
                `BI ${data[INSCRIPTION_EXERCICE]}`,
        }),
        createExtraColumn({
            key: SIFAC_VERSION,
            getValue: () => '',
        }),
        createExtraColumn({
            key: SIFAC_PIECE_TYPE,
            getValue: () => '',
        }),
    ],
    ASTRE_GF: [
        createExtraColumn({
            key: ASTRE_COLLECTIVITY_CODE,
            getValue: (data: InscriptionT) => {
                // ASTRE GF has a COLL_CODE column that doesn't exist in our schema,
                // so we extract it from the budget name
                const budgetName = data[BUDGET_NAME_FIELD];
                return budgetName.split('-')[0].trim();
            },
        }),
        createExtraColumn({
            key: BUDGET_CODE_FIELD,
            getValue: (data: InscriptionT): string =>
                data[BUDGET_CODE_FIELD]?.toString() ?? '',
        }),
        createExtraColumn({
            key: ASTRE_INSCRIPTION_PHASE_TYPE,
            getValue: (data: InscriptionT, phase: BudgetPhases): string =>
                phase === BudgetPhases.SUPPLEMENTARY_BUDGET ? 'DM' : 'BP',
        }),
        createExtraColumn({
            key: ASTRE_NUM_DM,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_NIV_PRO,
            getValue: () => 'SERV',
        }),
        createExtraColumn({
            key: ASTRE_CHAPTER_CODE,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_NUM_SCHAP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_NUM_PRG,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_EXPENSE_INCOME,
            getValue: (data: InscriptionT): string =>
                data[INSCRIPTION_EXPENSE_INCOME] ===
                BudgetExpenseOrIncome.EXPENSE
                    ? 'D'
                    : 'R',
        }),
        createExtraColumn({
            key: ASTRE_REAL_ORDER,
            getValue: (data: InscriptionT): string =>
                data[REAL_ORDER_FIELD] === BudgetRealOrOrder.REAL ? 'R' : 'O',
        }),
        createExtraColumn({
            key: ASTRE_CODE_SECTION,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_INSCRIPTION_COMMENT,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_MNT_HYP2_PREV,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_MNT_HYP3_PREV,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_IDENT_INT,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_NUM_ENR,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_IND_NIV_TRAIT,
            getValue: () => '',
        }),
        createExtraColumn({
            key: ASTRE_IND_VALID,
            getValue: () => '',
        }),
    ],
    JVS_FINANCES: [
        createExtraColumn({
            key: CHAPTER_FIELD,
            getValue: (data: InscriptionT) => `Cha = ${data[CHAPTER_FIELD]}`,
        }),
        createExtraColumn({
            key: CHAPTER_LABEL_FIELD,
            getValue: (data: InscriptionT) =>
                removeFieldPrefix(CHAPTER_FIELD, CHAPTER_LABEL_FIELD, data),
        }),
        createExtraColumn({
            key: NATURE_FIELD,
            getValue: (data: InscriptionT) => `Art = ${data[NATURE_FIELD]}`,
        }),
        createExtraColumn({
            key: FUNCTION_FIELD,
            getValue: (data: InscriptionT) => `Fon = ${data[FUNCTION_FIELD]}`,
        }),
        createExtraColumn({
            key: FUNCTION_LABEL_FIELD,
            getValue: (data: InscriptionT) =>
                removeFieldPrefix(FUNCTION_FIELD, FUNCTION_LABEL_FIELD, data),
        }),
        createExtraColumn({
            key: ANALYTIC_FIELD,
            getValue: (data: InscriptionT) => `Ana = ${data[ANALYTIC_FIELD]}`,
        }),
        createExtraColumn({
            key: GESTIONNAIRE_CODE_FIELD,
            getValue: (data: InscriptionT) =>
                `Ser = ${data[GESTIONNAIRE_CODE_FIELD]}`,
        }),
        createExtraColumn({
            key: NATURE_LABEL_FIELD,
            getValue: (data: InscriptionT) =>
                removeFieldPrefix(NATURE_FIELD, NATURE_LABEL_FIELD, data),
        }),
        createExtraColumn({
            key: OPERATION_FIELD,
            getValue: (data: InscriptionT) => `Ope = ${data[OPERATION_FIELD]}`,
        }),
        createExtraColumn({
            key: OPERATION_NAME_FIELD,
            getValue: (data: InscriptionT) =>
                removeFieldPrefix(OPERATION_FIELD, OPERATION_NAME_FIELD, data),
        }),
        createExtraColumn({
            key: ANALYTIC_NAME_FIELD,
            getValue: (data: InscriptionT) =>
                `${data[ANALYTIC_NAME_FIELD]}`.replace(
                    `${data[ANALYTIC_FIELD]} - `,
                    '',
                ),
        }),
        createExtraColumn({
            key: JVS_VOTE,
            getValue: () => '',
        }),
        createExtraColumn({
            key: JVS_REPORT,
            getValue: () => '',
        }),
    ],
    SEDIT_FINANCES: [
        createExtraColumn({
            key: SEDIT_PROPOSE_AP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: SEDIT_PROPOSE_CP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: SEDIT_VOTE_AP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: SEDIT_REPORTE_CP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: REAL_ORDER_FIELD,
            getValue: (data: InscriptionT) => {
                if (data[REAL_ORDER_FIELD] === BudgetRealOrOrder.REAL)
                    return 'R';
                if (
                    data[REAL_ORDER_FIELD] === BudgetRealOrOrder.ORDER &&
                    ['041', '043'].includes(data[CHAPTER_FIELD] ?? '')
                ) {
                    return 'I';
                }
                return 'E';
            },
        }),
        createExtraColumn({
            key: ANALYTIC_POST_1_CODE,
            getValue: (data: InscriptionT) => data[ANALYTIC_POST_1_CODE] ?? '-',
        }),
        createExtraColumn({
            key: ANALYTIC_POST_2_CODE,
            getValue: (data: InscriptionT) => data[ANALYTIC_POST_2_CODE] ?? '-',
        }),
        createExtraColumn({
            key: ANALYTIC_POST_3_CODE,
            getValue: (data: InscriptionT) => data[ANALYTIC_POST_3_CODE] ?? '-',
        }),
        createExtraColumn({
            key: ANALYTIC_POST_4_CODE,
            getValue: (data: InscriptionT) => data[ANALYTIC_POST_4_CODE] ?? '-',
        }),
    ],
    SEDIT_FINANCES_GFDE: [
        createExtraColumn({
            key: SEDIT_PROPOSE_AP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: SEDIT_PROPOSE_CP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: SEDIT_VOTE_AP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: SEDIT_REPORTE_CP,
            getValue: () => '',
        }),
        createExtraColumn({
            key: REAL_ORDER_FIELD,
            getValue: (data: InscriptionT) => {
                if (data[REAL_ORDER_FIELD] === BudgetRealOrOrder.REAL)
                    return 'R';
                if (
                    data[REAL_ORDER_FIELD] === BudgetRealOrOrder.ORDER &&
                    ['041', '043'].includes(data[CHAPTER_FIELD] ?? '')
                ) {
                    return 'I';
                }
                return 'E';
            },
        }),
    ],
    GRAND_ANGLE: [
        createExtraColumn({
            key: OP_PROG_GRAND_ANGLE_INTERNAL_ID,
            getValue: (data: InscriptionT) => {
                const value =
                    data[SECONDARY_BUDGET_AXIS_ELEMENT_SOFTWARE_ID]?.split(
                        '@@',
                    )?.[1];
                return value ? parseInt(value) : '';
            },
        }),
        createExtraColumn({
            key: GESTIONNAIRE_CODE_FIELD,
            getValue: (data: InscriptionT) => {
                const value = data[GESTIONNAIRE_CODE_FIELD];
                return value ? parseInt(value) : '';
            },
        }),
        createExtraColumn({
            key: GESTIONNAIRE_LABEL_WITHOUT_CODE,
            getValue: (data: InscriptionT) =>
                removeFieldPrefix(
                    GESTIONNAIRE_CODE_FIELD,
                    GESTIONNAIRE_FIELD,
                    data,
                ),
        }),
        createExtraColumn({
            key: SBA_LABEL_WITHOUT_CODE,
            getValue: (data: InscriptionT) =>
                removeFieldPrefix(
                    SECONDARY_BUDGET_AXIS_ELEMENT_CODE,
                    SECONDARY_BUDGET_AXIS_ELEMENT_NAME_FIELD,
                    data,
                ),
        }),
        createExtraColumn({
            key: ENVELOPPE_GRAND_ANGLE_INTERNAL_ID,
            getValue: (data: InscriptionT) => {
                const value = data[ENVELOPPE_SOFTWARE_ID]?.split('@@')?.[1];
                return value ? parseInt(value) : '';
            },
        }),
        createExtraColumn({
            key: OP_PG,
            getValue: (_data, _phase, sourceTable) =>
                sourceTable === OPERATION_TABLE ? 1 : 2,
        }),
        createExtraColumn({
            key: BUDGET_LINE_OPERATION_VENTILATION_CODE,
            getValue: (data: InscriptionT) => {
                const value = data[BUDGET_LINE_OPERATION_VENTILATION_CODE];
                return value ? parseInt(value) : '';
            },
        }),
        createExtraColumn({
            key: BUDGET_LINE_ENVELOPPE_VENTILATION_CODE,
            getValue: (data: InscriptionT) => {
                const value = data[BUDGET_LINE_ENVELOPPE_VENTILATION_CODE];
                return value ? parseInt(value) : '';
            },
        }),
        createExtraColumn({
            key: ANALYTIC_NATURE_CODE,
            getValue: (data: InscriptionT) => {
                const value = data[ANALYTIC_NATURE_CODE];
                return value ? parseInt(value) : '';
            },
        }),
        createExtraColumn({
            key: ANALYTIC_NATURE_LABEL_WITHOUT_CODE,
            getValue: (data: InscriptionT) =>
                removeFieldPrefix(
                    ANALYTIC_NATURE_CODE,
                    ANALYTIC_NATURE_NAME,
                    data,
                ),
        }),
        createExtraColumn({
            key: IMPUTATION,
            getValue: (data: InscriptionT) =>
                `${data[NATURE_FIELD]}//${data[SUB_FUNCTION_FIELD]}`,
        }),
    ],
};

type FilterDefinition = {
    label: string;
    values: string[];
};

const SIFAC_SOFTWARE = 'SIFAC';
export const BUDGET_PROPOSAL_CUSTOM_FILTER_VALUES: Record<
    string,
    FilterDefinition
> = {
    [SIFAC_SOFTWARE]: { label: LINE_CODE_FIELD, values: ['9G', '9F'] },
    default: { label: '', values: [] },
};

const PHASE_SPECIFIC_COLUMNS = {
    [BudgetPhases.CADRAGE]: [],
    [BudgetPhases.PROPOSITION_SERVICES]: [SERVICE_PROPOSAL_AMOUNT],
    [BudgetPhases.ARBITRAGE]: [SIMULATED_ARBITRATED_AMOUNT],
    [BudgetPhases.VOTE]: [PRIMITIVE_BUDGET_AMOUNT],
    [BudgetPhases.SUPPLEMENTARY_BUDGET]: [SUPPLEMENTARY_BUDGET_AMOUNT],
    [BudgetPhases.ARCHIVED]: [],
} as const;

/**
 * Returns extra empty columns to be displayed in the exported file
 * Currently this is used by JVS finances only
 */
export const getEmptyPhaseColumns = (
    software: string,
    phase: BudgetPhases,
): ExtraColumn[] => {
    let keys: string[] = [];
    if (software === 'JVS_FINANCES') {
        if (phase === BudgetPhases.SUPPLEMENTARY_BUDGET) {
            keys = [JVS_PRIMITIVE, JVS_MOD, JVS_CUM, JVS_REAL, JVS_AVAI];
        }
        if (
            [
                BudgetPhases.PROPOSITION_SERVICES,
                BudgetPhases.VOTE,
                BudgetPhases.ARBITRAGE,
            ].includes(phase)
        ) {
            keys = [
                JVS_PRIMITIVE_N1,
                JVS_SUPP_N1,
                JVS_MOD_N1,
                JVS_CUM_N1,
                JVS_REAL_N1,
                JVS_AVAI_N1,
            ];
        }
    }

    return keys.map((key) => ({
        label: '',
        key,
        getValue: () => '',
        type: 'text',
    }));
};

export const getInscriptionColumnsToExport = (
    phase: BudgetPhases,
    software: keyof typeof COMMON_INSCRIPION_COLUMNS_TO_EXPORT,
) => {
    if (!Object.hasOwnProperty.call(PHASE_SPECIFIC_COLUMNS, phase)) {
        console.error(`Unknown phase when exporting: ${phase}`);
        return COMMON_INSCRIPION_COLUMNS_TO_EXPORT[software];
    }

    return [
        ...COMMON_INSCRIPION_COLUMNS_TO_EXPORT[software],
        ...PHASE_SPECIFIC_COLUMNS[phase],
    ];
};

export const SPLIT_BY = '..';
export const JOIN_BY = ' ';

export const BUDGET_LINE_STATUS_TODO = 'todo';
export const BUDGET_LINE_STATUS_TO_VALIDATE = 'to_validate';
export const BUDGET_LINE_STATUS_TO_ARBITRATE = 'to_arbitrate';
export const BUDGET_LINE_STATUS_READY = 'ready';
export const BUDGET_LINE_STATUS_ARBITRATED = 'arbitrated';
export const BUDGET_LINE_STATUS_EMPTY = 'empty';
export const BUDGET_LINE_STATUS_VOTED = 'voted';
export const BUDGET_LINE_STATUS_OBSOLETE = 'obsolete';
export const BUDGET_LINE_STATUS_ARCHIVED = 'archived';

// Each ventilation field in the back end corresponds to zero, one or more fields in the front end.
// For example 'nature_id' becomes 'nature.number' and 'nature.label'
export const BUDGET_LINES_VENTILATION_COLUMNS_PER_FIELD = {
    [BUDGET_LINE_BUDGET_ID]: {
        [DimensionType.Code]: BUDGET_CODE_FIELD,
        [DimensionType.Label]: BUDGET_NAME_FIELD,
    },
    [BUDGET_LINE_ANTENNA_ID]: {
        [DimensionType.Code]: ANTENNA_FIELD,
        [DimensionType.Label]: ANTENNA_NAME_FIELD,
    },
    [BUDGET_LINE_NATURE_ID]: {
        [DimensionType.Code]: NATURE_FIELD,
        [DimensionType.Label]: NATURE_LABEL_FIELD,
    },
    [BUDGET_LINE_SUB_NATURE_ID]: {
        [DimensionType.Code]: SUB_NATURE_FIELD,
        [DimensionType.Label]: SUB_NATURE_LABEL_FIELD,
    },
    [BUDGET_LINE_FUNCTION_ID]: {
        [DimensionType.Code]: FUNCTION_FIELD,
        [DimensionType.Label]: FUNCTION_LABEL_FIELD,
    },
    [BUDGET_LINE_GESTIONNAIRE_ID]: {
        [DimensionType.Code]: GESTIONNAIRE_CODE_FIELD,
        [DimensionType.Label]: GESTIONNAIRE_FIELD,
        [DimensionType.SoftwareId]: GESTIONNAIRE_SOFTWARE_ID,
    },
    [BUDGET_LINE_GESTIONNAIRE_CODE_FIELD]: {
        [DimensionType.Code]: GESTIONNAIRE_CODE_FIELD,
        [DimensionType.Label]: GESTIONNAIRE_FIELD,
        [DimensionType.SoftwareId]: GESTIONNAIRE_SOFTWARE_ID,
    },
    [BUDGET_LINE_OPERATION_ID]: {
        [DimensionType.Code]: OPERATION_FIELD,
        [DimensionType.Label]: OPERATION_NAME_FIELD,
        [DimensionType.SoftwareId]: OPERATION_SOFTWARE_ID,
    },
    [BUDGET_LINE_ANALYTIC_ID]: {
        [DimensionType.Code]: ANALYTIC_FIELD,
        [DimensionType.Label]: ANALYTIC_NAME_FIELD,
    },
    [BUDGET_LINE_ORG_CHART]: {
        [DimensionType.Code]: ORG_CHART_FINANCE_CODE_FIELD,
        [DimensionType.Label]: ORG_CHART_FINANCE_FIELD,
        [DimensionType.SoftwareId]: ORG_CHART_FINANCE_SOFTWARE_ID,
    },
    [BUDGET_LINE_ORG_CHART_FINANCE_ID]: {
        [DimensionType.Code]: ORG_CHART_FINANCE_CODE_FIELD,
        [DimensionType.Label]: ORG_CHART_FINANCE_FIELD,
        [DimensionType.SoftwareId]: ORG_CHART_FINANCE_SOFTWARE_ID,
    },
    [REAL_ORDER_FIELD]: {
        [DimensionType.Code]: REAL_ORDER_FIELD,
        [DimensionType.Label]: REAL_ORDER_FIELD,
    },
    [LINE_CODE_FIELD]: {
        [DimensionType.Code]: LINE_CODE_FIELD,
        [DimensionType.Label]: LINE_NAME_FIELD,
    },
    // for sifac we want to filter on budgetLine.lineCode and display budgetline.code
    [BUDGET_LINE_CODE]: {
        [DimensionType.Code]: LINE_CODE_FIELD,
        [DimensionType.Label]: BUDGET_LINE_CODE,
    },
    [EXPENSE_INCOME_FIELD]: {
        [DimensionType.Code]: EXPENSE_INCOME_FIELD,
        [DimensionType.Label]: EXPENSE_INCOME_FIELD,
    },
    [SECTION_FIELD]: {
        [DimensionType.Code]: SECTION_FIELD,
        [DimensionType.Label]: SECTION_FIELD,
    },
    [BUDGET_LINE_ANALYTIC_POST_1_ID]: {
        [DimensionType.Code]: ANALYTIC_POST_1_CODE,
        [DimensionType.Label]: ANALYTIC_POST_1_NAME,
    },
    [BUDGET_LINE_ANALYTIC_POST_2_ID]: {
        [DimensionType.Code]: ANALYTIC_POST_2_CODE,
        [DimensionType.Label]: ANALYTIC_POST_2_NAME,
    },
    [BUDGET_LINE_ANALYTIC_POST_3_ID]: {
        [DimensionType.Code]: ANALYTIC_POST_3_CODE,
        [DimensionType.Label]: ANALYTIC_POST_3_NAME,
    },
    [BUDGET_LINE_ANALYTIC_POST_4_ID]: {
        [DimensionType.Code]: ANALYTIC_POST_4_CODE,
        [DimensionType.Label]: ANALYTIC_POST_4_NAME,
    },
    [BUDGET_LINE_STRAT_FOCUS_ID]: {
        [DimensionType.Code]: STRAT_FOCUS_CODE,
        [DimensionType.Label]: STRAT_FOCUS_NAME,
    },
    [BUDGET_LINE_AP_ASSIGNMENT_ID]: {
        [DimensionType.Code]: AP_CODE,
        [DimensionType.Label]: AP_LABEL,
        [DimensionType.Other]: AP_START_YEAR,
    },
    [BUDGET_LINE_OPERATION_SEGMENT_ID]: {
        [DimensionType.Code]: OPERATION_SEGMENT_CODE,
        [DimensionType.Label]: OPERATION_SEGMENT_NAME,
    },
    [BUDGET_LINE_ENVELOPPE_ID]: {
        [DimensionType.Code]: ENVELOPPE_CODE,
        [DimensionType.Label]: ENVELOPPE_LABEL,
    },
    [BUDGET_LINE_BUDGET_LINE_PROGRAM_ID]: {
        [DimensionType.Code]: BUDGET_LINE_PROGRAM_CODE,
        [DimensionType.Label]: BUDGET_LINE_PROGRAM_NAME,
    },
    [BUDGET_LINE_ANALYTIC_NATURE_ID]: {
        [DimensionType.Code]: ANALYTIC_NATURE_CODE,
        [DimensionType.Label]: ANALYTIC_NATURE_NAME,
    },
    [BUDGET_LINE_SUB_FUNCTION_ID]: {
        [DimensionType.Code]: SUB_FUNCTION_NUMBER,
        [DimensionType.Label]: SUB_FUNCTION_LABEL,
    },
} as const;

export const ORDERED_DIMENSIONS_FOR_IMPUTATION_CONCATENATION = [
    GESTIONNAIRE_CODE_FIELD,
    ORG_CHART_FINANCE_CODE_FIELD,
    NATURE_FIELD,
    SUB_NATURE_FIELD,
    CHAPTER_FIELD,
    FUNCTION_FIELD,
    ANALYTIC_FIELD,
    ANTENNA_FIELD,
    REAL_ORDER_FIELD,
    OPERATION_FIELD,
    SUPER_OPERATION_FIELD,
];
